import React from "react";
import { intl } from "../i18n/TypedIntl";
import { NimblePicker } from "emoji-mart";
import { BaseEmoji } from "emoji-mart/dist-es/utils/emoji-index/nimble-emoji-index";
import "emoji-mart/css/emoji-mart.css";
const data = require("emoji-mart/data/all.json");

// Filter bugged emojis (white with dark contours);
const { relaxed, white_frowning_face, ...rest } = data.emojis;
const filteredEmojiData = { ...data, emojis: rest };

interface Props {
  onEmojiPicked: (emoji: BaseEmoji) => void;
}

export class EmojiPicker extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  pickEmoji = (emoji: BaseEmoji) => {
    this.props.onEmojiPicked(emoji);
  };

  render() {
    const i18nPicker = {
      search: intl.formatMessage("search"),
      notfound: intl.formatMessage("conversation.input.emojiPicker.notfound"),
      skintext: intl.formatMessage("conversation.input.emojiPicker.skintext"),
      categories: {
        search: intl.formatMessage("conversation.input.emojiPicker.searchResults"),
        recent: intl.formatMessage("conversation.input.emojiPicker.recent"),
        people: intl.formatMessage("conversation.input.emojiPicker.people"),
        nature: intl.formatMessage("conversation.input.emojiPicker.nature"),
        foods: intl.formatMessage("conversation.input.emojiPicker.foods"),
        activity: intl.formatMessage("conversation.input.emojiPicker.activity"),
        places: intl.formatMessage("conversation.input.emojiPicker.places"),
        objects: intl.formatMessage("conversation.input.emojiPicker.objects"),
        symbols: intl.formatMessage("conversation.input.emojiPicker.symbols"),
        flags: intl.formatMessage("conversation.input.emojiPicker.flags"),
        custom: intl.formatMessage("search")
      }
    };
    return (
      <NimblePicker
        native
        emojiSize={24}
        color={"#00AB8E"}
        data={filteredEmojiData}
        darkMode={false}
        emoji={""}
        recent={[
          "slightly_smiling_face",
          "grinning",
          "laughing",
          "wink",
          "disappointed",
          "sunglasses",
          "+1",
          "wave",
          "rocket"
        ]}
        defaultSkin={1}
        showSkinTones={false}
        perLine={10}
        showPreview={false}
        onClick={this.pickEmoji}
        emojiTooltip
        i18n={i18nPicker}
        style={{ width: "100%" }}
      />
    );
  }
}

// tslint:disable-next-line:no-default-export
export default EmojiPicker;
